module.exports = __webpack_public_path__ + "static/media/Untitled1_001.3c009fd3.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/Untitled1_001.png
// module id = 1387
// module chunks = 1